export default __webpack_public_path__ + "static/media/lettuce.3e0e1a76.png";